import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("foresta_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (r) => {
        // Auto-renovación silenciosa: si el backend mandó X-New-Token, lo guardamos.
        const newToken = r?.headers?.["x-new-token"] || r?.headers?.["X-New-Token"];
        if (newToken) {
            try { localStorage.setItem("foresta_token", newToken); } catch { /* noop */ }
        }
        return r;
    },
    (err) => {
        if (err?.response?.status === 401) {
            localStorage.removeItem("foresta_token");
            localStorage.removeItem("foresta_user");
            if (!window.location.pathname.startsWith("/login")
                && !window.location.pathname.startsWith("/activar")) {
                window.location.href = "/login";
            }
        }
        return Promise.reject(err);
    }
);

export function formatApiError(err) {
    const d = err?.response?.data?.detail;
    if (!d) return err?.message || "Ocurrió un error";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" · ");
    return JSON.stringify(d);
}
